import { getTradeTheme } from '../constants/tradeTheme';

export const PROVIDER_HIGHLIGHTS_LEAD_IN = 'Check out our featured local providers:';

/** Banner label for the `other` trade. Always rendered last in a provider's trade list. */
export const OTHER_CUSTOM_SERVICES_LABEL = 'Other Custom Services';

/**
 * Customer-facing trade name for the highlight banner.
 * @param {string | null | undefined} tradeId
 */
export function tradeLabel(tradeId) {
  if (tradeId === 'other') return OTHER_CUSTOM_SERVICES_LABEL;
  const theme = getTradeTheme(tradeId);
  if (theme?.name) return theme.name;
  return typeof tradeId === 'string' ? tradeId.trim() : '';
}

/**
 * One ticker segment: "Acme Plumbing · Covington · Plumbing, HVAC, Other Custom Services".
 * @param {{ BusinessName?: string, City?: string, Trades?: string[] } | null | undefined} highlight
 */
export function formatProviderHighlight(highlight) {
  if (!highlight || typeof highlight !== 'object') return '';

  const name = String(highlight.BusinessName ?? '').trim();
  const city = String(highlight.City ?? '').trim();
  const trades = (Array.isArray(highlight.Trades) ? highlight.Trades : [])
    .map(tradeLabel)
    .filter(Boolean)
    .sort((a, b) => {
      if (a === OTHER_CUSTOM_SERVICES_LABEL) return 1;
      if (b === OTHER_CUSTOM_SERVICES_LABEL) return -1;
      return 0;
    });

  return [name, city, trades.join(', ')].filter(Boolean).join(' · ');
}

/**
 * @param {{ BusinessSlug?: string } | null | undefined} highlight
 */
export function providerHighlightPath(highlight) {
  const slug = String(highlight?.BusinessSlug ?? '').trim();
  return slug ? `/storefront/${encodeURIComponent(slug)}` : '';
}
